import {Component, Input, OnInit} from '@angular/core';
import {DossierIntervention} from 'app/models/dossier_intervention.model';
import {FicheIntervention} from 'app/models/ficheIntervention.model';
import {FicheInterventionService} from 'app/services/fiche-intervention.service';
import {MatDialog} from '@angular/material/dialog';
import {
    FormFicheInterventionComponent
} from './edit-fiche-intervention/form-fiche-intervention/form-fiche-intervention.component';
import {FuseConfirmationService} from '@fuse/services/confirmation';
import {HttpErrorResponse} from '@angular/common/http';
import {UserService} from 'app/core/user/user.service';
import {WorkOrderTypeService} from '../../../services/work-order-type.service';
import {WorkOrderType} from '../../../models/workOrderType.model';

@Component({
    selector: 'app-fiche-intervention',
    templateUrl: './fiche-intervention.component.html',
    styleUrls: ['./fiche-intervention.component.scss']
})
export class FicheInterventionComponent implements OnInit {

    @Input() currentDossierIntervention: DossierIntervention;
    fichesInterventions: FicheIntervention[] = [];
    currentFicheIntervention: FicheIntervention;
    isFicheInterventionLoaded: boolean = false;

    get isLoaded(): boolean {
        return this.isFicheInterventionLoaded;
    }

    constructor(
        private ficheInterventionService: FicheInterventionService,
        private _userService: UserService,
        public dialog: MatDialog,
        private fuseConfirmationService: FuseConfirmationService,
    ) {
    }

    ngOnInit(): void {
        this.getFichesInterventions();
    }

    getFichesInterventions() {
        this.ficheInterventionService.getFichesInterventions(this.currentDossierIntervention.id).subscribe((fichesInterventions) => {
            this.fichesInterventions = fichesInterventions;
        });
    }



    add() {
        this.currentFicheIntervention = new FicheIntervention();
        this.currentFicheIntervention.id = 0;
        this.afficherFormFicheIntervention();
    }

    edit(id: number) {
        this.currentFicheIntervention = this.fichesInterventions.find(ficheIntervention => ficheIntervention.id == id);
        this.afficherFormFicheIntervention();
    }

    afficherFormFicheIntervention() {
        const dialogRef = this.dialog.open(FormFicheInterventionComponent, {
            data: {
                currentFicheIntervention: this.currentFicheIntervention,
                currentDossierIntervention: this.currentDossierIntervention
            },
            width: '50%',
        });

        dialogRef.afterClosed().subscribe((result) => {
            if (result != undefined) {
                this.getFichesInterventions();
            }
        });
    }

    delete(id: number) {
        if (this.isAdmin) {
            const confirmation = this.fuseConfirmationService.open({
                title: 'Suppression d\'une fiche de l\'intervention',
                message: 'Êtes-vous certain de vouloir supprimer cette fiche de l\'intervention',
                actions: {
                    confirm: {
                        label: 'Supprimer'
                    }
                }
            });

            confirmation.afterClosed().subscribe((result) => {
                if (result === 'confirmed') {
                    this.ficheInterventionService.delete(id).subscribe(
                        (response) => {
                            this.fichesInterventions = this.fichesInterventions.filter(ficheIntervention => ficheIntervention.id != id);
                        },
                        (error) => {
                            console.log(error);
                            this.showErrors(error);
                        });
                }
            });
        }
    }

    get isAdmin(): boolean {
        return this._userService.getCurrentUser().role_id == 1;
    }

    showErrors(error: any) {
        //Gestion des erreurs laravel
        if (error instanceof HttpErrorResponse) {
            for (const key in error.error.errors) {
                //Todo
            }
        } else {
            error.forEach((element) => {
                //this.toastr.error(element);
            });
        }
    }

    /**
     * Track by function for ngFor loops
     *
     * @param index
     * @param item
     */
    trackByFn(index: number, item: any): any {
        return item.id || index;
    }
}
